import { useEffect, useState } from "react";

const T2_BG = "#0A0A0B";
const T2_TEXT = "#E8E1D2";
const T2_MUTED = "#7A756A";

export default function BrandReveal({ onDone }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fade = setTimeout(() => setFadeOut(true), 2100);
    const end = setTimeout(() => onDone && onDone(), 2600);
    const onKey = (e) => { if (e.key === "Escape") onDone && onDone(); };
    window.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(fade);
      clearTimeout(end);
      window.removeEventListener("keydown", onKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const font = {
    fontFamily: "'Bricolage Grotesque', system-ui, sans-serif",
    fontWeight: 800,
    textTransform: "uppercase",
    color: T2_TEXT,
    letterSpacing: "-0.06em",
    lineHeight: 0.9,
    fontSize: "clamp(120px, 18vw, 280px)",
  };

  return (
    <div
      data-testid="brand-reveal"
      role="presentation"
      onClick={() => onDone && onDone()}
      className={`fixed inset-0 z-[100] transition-opacity duration-500 ${fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      style={{ background: T2_BG, overflow: "hidden" }}
    >
      <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", justifyContent: "center", paddingLeft: "clamp(24px, 6vw, 96px)" }}>
        <div data-testid="brand-reveal-e" style={font}>
          <span style={{ display: "inline-block", color: "#E6A55A", animation: "letter-rise 0.7s cubic-bezier(.2,.9,.2,1) 0s both" }}>E</span>
        </div>
        <div data-testid="brand-reveal-renown" style={{ ...font, marginTop: "-0.04em" }}>
          <span style={{ display: "inline-block", animation: "letter-rise 0.7s cubic-bezier(.2,.9,.2,1) 0.25s both" }}>R</span>
          <span style={{ display: "inline-block", animation: "letter-rise 0.7s cubic-bezier(.2,.9,.2,1) 0.32s both" }}>E</span>
          <span style={{ display: "inline-block", animation: "letter-rise 0.7s cubic-bezier(.2,.9,.2,1) 0.39s both" }}>N</span>
          <span style={{ display: "inline-block", animation: "letter-rise 0.7s cubic-bezier(.2,.9,.2,1) 0.46s both" }}>O</span>
          <span style={{ display: "inline-block", animation: "letter-rise 0.7s cubic-bezier(.2,.9,.2,1) 0.53s both" }}>W</span>
          <span style={{ display: "inline-block", animation: "letter-rise 0.7s cubic-bezier(.2,.9,.2,1) 0.60s both" }}>N</span>
        </div>
      </div>

      <div style={{ position: "absolute", bottom: 32, left: "50%", transform: "translateX(-50%)", fontFamily: "'JetBrains Mono', monospace", fontSize: 10, letterSpacing: "0.3em", textTransform: "uppercase", color: T2_MUTED }}>
        Click or press esc to skip
      </div>
    </div>
  );
}
